import React from 'react';

export const AmbientBackground = () => (
  <div className="ambient-bg" aria-hidden data-testid="ambient-background">
    <span className="orb orb-pink" />
    <span className="orb orb-blue" />
    <span className="orb orb-green" />
    <span className="orb orb-orange" />
    <span className="grain" />
  </div>
);

export default AmbientBackground;
